<div class="input-with-button relative">
  <mat-label class="form-mat-label">{{ label }}   <mat-icon class="info-icon" *ngIf="this.group"  matTooltip="Select text → Ctrl + S to save" >help_outline</mat-icon> </mat-label>
  <span class="text-[10px] absolute right-0 top-6 text-max-length" *ngIf="maxLength > 0">



    <span [ngClass]="{
        'text-red': hasError('maxlength'),
      }"> {{ contentLength }} </span>/{{ maxLength }}</span>
  <mat-form-field appearance="outline" class="description-text-area" [class]="customClass">
    <textarea #editor (keydown)="onKeyDown($event, editor)" [disabled]="disabled"
      [maxlength]="maxLength > 0 ? maxLength : null" matInput [name]="label" [placeholder]="placeholder"
      [(ngModel)]="content" (ngModelChange)="onContentChange($event)">
    </textarea>
    <mat-error class="!flex" *ngIf="hasError('required')">
      {{ label }} is required
    </mat-error>

    <mat-error class="!flex" *ngIf="hasError('minlength')">
      Minimum length not met
    </mat-error>

    <mat-error class="!flex" *ngIf="hasError('maxlength')">
      Maximum {{maxLength}} allowed
    </mat-error>

  </mat-form-field>


  <div class="button-container" *ngIf="generateTextClick.observed">
    <!-- Horizontal autofill + dropdown in one row -->
    <div class="autofill-group">
      <button mat-stroked-button color="primary" class="autofill" (click)="generateText()"
        [disabled]="isEmptyArrayProvided">
        Autofill{{ currentLang ? " (" + currentLang + ")" : "" }}
      </button>
      <ng-container *ngIf="autofillOptions.length > 0">
        <button mat-icon-button class="dropdown-btn" [matMenuTriggerFor]="menuRef">
          <mat-icon>arrow_drop_down</mat-icon>
        </button>

        <mat-menu #menuRef="matMenu">
          <button mat-menu-item *ngFor="let option of autofillOptions; trackBy: trackByLabel"
            (click)="onMenuOptionSelected(option)">
            {{ option.name }}
          </button>
        </mat-menu>
      </ng-container>
    </div>

    <!-- Helper text below -->
    <span class="autofill-help text-sm text-gray-400" *ngIf="selectedAutoFill?.name">
      Autofill via {{ selectedAutoFill?.name }} Strategy
    </span>
    <span class="autofill-help text-sm text-gray-400" *ngIf="isEmptyArrayProvided">
      No Autofill available
    </span>


  </div>
</div>
